import { Link } from 'react-router-dom';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import PageHeader from '../components/ui/PageHeader';
import { FadeIn, FadeInStagger, FadeInStaggerItem } from '../components/ui/AnimatedSection';
import { useTranslation } from 'react-i18next';
import type { Article } from '../data/blog';

export default function Blog() {
  const { t } = useTranslation();
  const blogArticles = t('blog.articles', { returnObjects: true }) as Article[];
  
  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      <PageHeader 
        title={t('blog.headerTitle')} 
        subtitle={t('blog.headerSubtitle')} 
        imagePath="/assets/luxury_interior.webp" 
      />

      <main className="flex-grow py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          
          <FadeIn className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-5xl font-serif text-black-deep mb-6">
              {t('blog.sectionTitle')}
            </h2>
            <div className="w-16 h-px bg-gold-400 mx-auto mb-8"></div>
            <p className="text-gray-500 font-light text-lg">
              {t('blog.sectionDesc')}
            </p>
          </FadeIn>

          <FadeInStagger className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            {blogArticles.map((article) => (
              <FadeInStaggerItem key={article.id} className="group cursor-pointer">
                <Link to={`/realisations/${article.id}`} className="block h-full bg-white border border-gray-100 rounded-sm overflow-hidden hover:shadow-2xl transition-all duration-500 flex flex-col">
                  
                  <div className="relative h-64 overflow-hidden">
                    <div className="absolute inset-0 bg-black-deep/10 group-hover:bg-transparent transition-colors duration-500 z-10"></div>
                    <img 
                      src={article.image} 
                      alt={article.title} 
                      className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-700"
                    />
                    <div className="absolute top-4 left-4 z-20 bg-black-deep text-white text-xs uppercase tracking-widest px-3 py-1">
                      {article.category}
                    </div>
                  </div>

                  <div className="p-8 flex-grow flex flex-col">
                    <p className="text-gold-500 text-xs font-bold uppercase tracking-widest mb-3">
                      {article.date}
                    </p>
                    <h3 className="text-2xl font-serif text-black-deep mb-4 group-hover:text-gold-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="text-gray-500 font-light text-sm leading-relaxed mb-6 flex-grow">
                      {article.excerpt}
                    </p>
                    <div className="text-black-deep text-xs uppercase tracking-widest font-bold group-hover:text-gold-500 transition-colors flex items-center">
                      {t('blog.readArticle')} <span className="ml-2 group-hover:translate-x-2 transition-transform">&rarr;</span>
                    </div>
                  </div>
                </Link>
              </FadeInStaggerItem>
            ))}
          </FadeInStagger>

        </div>
      </main>

      <Footer />
    </div>
  );
}
